<template>

  <div>
    <el-form :inline="true" :model="query" class="query-form" size="mini">

      <el-form-item class="query-form-item" label="分类">
        <el-select v-model="query.classify_id">
          <el-option label="全部" :value="0"></el-option>
          <el-option v-for="item in classifyList" :label="item.name" :value="item.id" :key="item.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="query-form-item" label="机器人">
        <el-select v-model="query.bot_id">
          <el-option label="全部" :value="0"></el-option>
          <el-option v-for="item in botList" :label="item.name" :value="item.id" :key="item.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="query-form-item" label="群组名称">
        <el-input v-model="query.name" placeholder="群组名称"></el-input>
      </el-form-item>

      <el-form-item class="query-form-item" label="状态">
        <el-select v-model="query.status" placeholder="状态">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="禁用" :value="0"></el-option>
          <el-option label="正常" :value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button-group>
          <el-button type="primary" icon="el-icon-refresh" @click="onReset"></el-button>
          <el-button type="primary" icon="search" @click="onSubmit">查询</el-button>
          <el-button type="primary" @click.native="handleForm(null,null)">新增</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;">
      <el-table
          v-loading="loading"
          :data="list"
          style="width: 100%;">
        <el-table-column
            width="50"
            label="ID"
            prop="id"
            fixed>
        </el-table-column>
        <el-table-column
            label="分类名称"
            fixed>
          <template slot-scope="scope">
            {{ classifyText(scope.row.classify_id) }} | {{scope.row.classify_id}}
          </template>
        </el-table-column>
        <el-table-column
            label="群组名称"
            prop="name">
        </el-table-column>
        <el-table-column
            label="链接"
            fixed>
          <template slot-scope="scope">
            <a :href="scope.row.link" target="_blank">{{ scope.row.link }}</a>
          </template>
        </el-table-column>
        <el-table-column
            label="机器人"
            fixed>
          <template slot-scope="scope">
            {{ botText(scope.row.bot_id) }} | {{scope.row.bot_id}}
          </template>
        </el-table-column>
        <el-table-column
            width="70"
            label="状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status | statusFilterType">{{ scope.row.status | statusFilterName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            width="150"
            label="创建时间">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time | parseTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
            width="150"
            label="更新时间">
          <template slot-scope="scope">
            <span>{{ scope.row.modified_time | parseTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click.native="handleForm(scope.$index, scope.row)">编辑
            </el-button>
            <el-button type="text" size="small" @click.native="handleDel(scope.$index, scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-scrollbar>

    <el-pagination
        :page-size="query.limit"
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :total="total">
    </el-pagination>

    <!--表单-->
    <el-dialog
        :close-on-click-modal="false"
        :title="formMap[formName]"
        :visible.sync="formVisible"
        :before-close="hideForm"
        width="85%"
        top="5vh">
      <el-form :model="formData" :rules="formRules" ref="dataForm">

        <el-form-item label="群组分类" prop="classify_id">
          <el-select v-model="formData.classify_id">
            <el-option :label="item.name" v-for="item in classifyList" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="机器人" prop="bot_id">
          <el-select v-model="formData.bot_id">
            <el-option :label="item.name" v-for="item in botList" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="群组名称" prop="name">
          <el-input v-model="formData.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="群组链接" prop="link">
          <el-input v-model="formData.link" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="formData.status">
            <el-radio :label="0">禁用</el-radio>
            <el-radio :label="1">正常</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="hideForm">取消</el-button>
        <el-button type="primary" @click.native="formSubmit()" :loading="formLoading">提交</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import {groupDelete, groupList, groupSave} from "../../api/group/group";
import {groupClassifyAll} from "../../api/group/groupClassify";
import {botAll} from "../../api/bot/bot";

const formJson = {
  id: "",
  classify_id: "",
  name: "",
  link: "",
  bot_id: "",
  status: 1,
};
export default {
  computed: {
    classifyText() {
      return id => {
        return this.classifyMap.get(id)
      }
    },
    botText() {
      return id => {
        return this.botMap.get(id)
      }
    },
  },
  data() {
    return {
      query: {
        classify_id: 0,
        bot_id: 0,
        name: "",
        status: -1,
        page: 1,
        limit: 20,
      },
      list: [],
      total: 0,
      loading: true,
      index: null,
      formName: null,
      formMap: {
        add: "新增",
        edit: "编辑"
      },
      formLoading: false,
      formVisible: false,
      formData: formJson,
      formRules: {
        name: [
          {required: true, message: "请输入名称", trigger: "blur"}
        ],
        link: [
          {required: true, message: "请输入链接", trigger: "blur"}
        ],
        status: [
          {required: true, message: "请选择状态", trigger: "change"}
        ]
      },
      deleteLoading: false,
      classifyList: [],
      classifyMap: new Map(),

      botList: [],
      botMap: new Map(),
    };
  },
  methods: {
    onReset() {
      this.$router.push({
        path: ""
      });
      this.query = {
        classify_id: 0,
        bot_id: 0,
        name: "",
        status: -1,
        page: 1,
        limit: 20,
      };
      this.getList();
      this.getClassifyList();
    },
    onSubmit() {
      this.$router.push({
        path: "",
        query: this.query
      });
      this.getList();
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getList();
    },
    getList() {
      this.loading = true;
      groupList(this.query)
          .then(response => {
            this.loading = false;
            if (response.code) {
              this.$message.error(response.message);
            }
            this.list = response.data.list || [];
            this.total = response.data.total || 0;
          })
          .catch(() => {
            this.loading = false;
            this.list = [];
            this.total = 0;
          });
    },
    // 隐藏表单
    hideForm() {
      // 更改值
      this.formVisible = !this.formVisible;
      return true;
    },
    // 刷新表单
    resetForm() {
      if (this.$refs["dataForm"]) {
        // 清空验证信息表单
        this.$refs["dataForm"].clearValidate();
        // 刷新表单
        this.$refs["dataForm"].resetFields();
      }
    },
    // 显示表单
    handleForm(index, row) {
      this.formVisible = true;
      this.formData = JSON.parse(JSON.stringify(formJson));
      if (row !== null) {
        this.formData = Object.assign({}, row);
      }
      this.formName = "add";
      if (index !== null) {
        this.index = index;
        this.formName = "edit";
      }
    },
    formSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.formLoading = true;
          let data = Object.assign({}, this.formData);
          groupSave(data, this.formName).then(response => {
            this.formLoading = false;
            if (response.code) {
              this.$message.error(response.message);
              return false;
            }
            if (this.formName === "add") {
              // 向头部添加数据
              if (response.data && response.data.id) {
                data.id = response.data.id;
                data.create_time = new Date()
                data.modified_time = new Date()
                this.list.unshift(data);
              }
            } else {
              data.modified_time = new Date()
              this.list.splice(this.index, 1, data);
            }
            this.$message.success("操作成功");
            // 刷新表单
            this.resetForm();
            this.hideForm()
          });
        }
      });
    },
    // 删除
    handleDel(index, row) {
      if (row.id) {
        this.$confirm("确认删除该记录吗?", "提示", {
          type: "warning"
        })
            .then(() => {
              let para = {id: row.id};
              this.deleteLoading = true;
              groupDelete(para)
                  .then(response => {
                    this.deleteLoading = false;
                    if (response.code) {
                      this.$message.error(response.message);
                      return false;
                    }
                    this.$message.success("删除成功");
                    // 刷新数据
                    this.list.splice(index, 1);
                  })
                  .catch(() => {
                    this.deleteLoading = false;
                  });
            })
            .catch(() => {
              this.$message.error("取消删除");
            });
      }
    },

    getClassifyList() {
      groupClassifyAll()
          .then(response => {
            this.loading = false;
            if (response.code) {
              this.$message.error(response.message);
              return
            }
            this.classifyList = response.data.list || [];
            this.classifyMap = new Map()
            for (let item of this.classifyList) {
              this.classifyMap.set(item.id, item.name)
            }
          })
          .catch(() => {
          });
    },
    getBotList() {
      botAll()
          .then(response => {
            this.loading = false;
            if (response.code) {
              this.$message.error(response.message);
              return
            }
            this.botList = response.data.list || [];
            this.botMap = new Map()
            for (let item of this.botList) {
              this.botMap.set(item.id, item.name)
            }
          })
          .catch(() => {
          });
    },
  },
  filters: {
    statusFilterType(status) {
      const statusMap = {
        0: "danger",
        1: "success",
      };
      return statusMap[status];
    },
    statusFilterName(status) {
      const statusMap = {
        0: "禁用",
        1: "正常",
      };
      return statusMap[status];
    },
  },
  mounted() {
  },
  created() {
    // 将参数拷贝进查询对象
    let query = this.$route.query;
    this.query = Object.assign(this.query, query);
    this.query.limit = parseInt(this.query.limit);
    // 加载表格数据
    this.getList();
    this.getClassifyList();
    this.getBotList();
  }
};
</script>

<style lang="less" scoped>
</style>
